<template>
  <div>
    <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Avisos</v-toolbar-title>
            <v-spacer/>
  </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="movimientos"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.nombres }}</td>
          <td class="text-xs-left">{{ props.item.apellido_paterno }}</td>
          <td class="text-xs-left">{{ props.item.apellido_materno }}</td>
          <td class="text-xs-left">{{ props.item.fecha_entrega }}</td>
          <td class="text-xs-left" v-if="props.item.leido">SI</td>
          <td class="text-xs-left" v-else>NO</td>
          <td class="text-xs-left">{{ props.item.fecha_lectura }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    pagination: {},
    totalItems: 0,
    loading: false,
    movimientos: [],
    headers: [
      { text: 'Nombre', value: 'nombres', sortable: false },
      { text: 'Apellido Paterno', value: 'apellido_paterno', sortable: false },
      { text: 'Apellido Materno', value: 'apellido_materno', sortable: false },
      { text: 'Fecha Entrega', value: 'fecha_entrega', sortable: false },
      { text: 'Leido', value: 'leido', sortable: false },
      { text: 'Fecha Lectura', value: 'fecha_lectura', sortable: false },
    ],
  }),
  methods: {
    back() {
      this.$router.back();
    },
    fetchDetalle() {
      this.loading = true;
      const {
        sortBy, descending, page, rowsPerPage,
      } = this.pagination;

      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
        aviso_id: this.$route.params.id,
      };
      this.$store.dispatch('detallesAviso/obtenerDetalleAviso', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.movimientos = data.movimientos;
          this.loading = false;
        });
    },
  },
  computed: {
  },
  watch: {
    pagination: {
      handler() {
        this.fetchDetalle();
      },
      deep: true,
    },
  },
};
</script>
